export default __webpack_public_path__ + "assets/reset.80a6e1615fc013684ad8047dba5ce064.svg";